import { useState } from "react";

function useGetChecked() {
    const [selectedRowKeysHe, setSelectedRowKeysHe] = useState({})
    const [selectedRowKeysAi, setSelectedRowKeysAi] = useState({})
    const [heActiveKeys, setHeActiveKeys] = useState([])
    const [aiActiveKeys, setAiActiveKeys] = useState([])

    const checkIfHasSelectedInTable = () => {
        if (!Object.keys(selectedRowKeysHe).length && !Object.keys(selectedRowKeysAi).length) return false
        const allHe = Object.values(selectedRowKeysHe).reduce((acc, items) => ([
            ...acc,
            ...items
        ]), [])
        const allAi = Object.values(selectedRowKeysAi).reduce((acc, items) => ([
            ...acc,
            ...items
        ]), [])
        if (allHe.length || allAi.length) return true
        return false
    }
    return {
        heActiveKeys,
        setHeActiveKeys,
        aiActiveKeys,
        setAiActiveKeys,
        selectedRowKeysHe,
        setSelectedRowKeysHe,
        selectedRowKeysAi,
        setSelectedRowKeysAi,
        hasChecked: checkIfHasSelectedInTable()
    };
}

export default useGetChecked;
